import { uniq } from "lodash";

/** Properties set per player rather than per experience: every field listed by one of the roles */
export const getDeviceScopedKeys = (roles?: FormationRoleMap): string[] =>
  uniq(Object.values(roles || {}).flatMap(role => role.fields || []));

export const hasFormationRoles = (roles?: FormationRoleMap): roles is FormationRoleMap =>
  !!roles && Object.keys(roles).length > 0;
